module.exports = __webpack_public_path__ + "img/champions-series_banner_revised.ad2f4282.jpeg";